const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandkrBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "brandkar",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 244.55 152.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "fae9e242-94ec-4263-974a-d1789f2596df",
    "data-name": "border",
    d: "M1.73,88.7c.59-5.89,5-17.42,5.78-19.22s0-15.23,11-17.31c3.51-.66.68-6.31,7.48-7.9s11.17,1.19,11.72,3.34,3.2,1,5.15.8,2.19-4.33,3.61-5.49,75-.62,75.78-.81,4.14-5.53,7.09-7.31,5.34,1.38,6.28,3.19,7.94-.32,10.28-2.21,7.73-8.19,7.65-8,5.33,0,5.33,0l.54-15.85-6.34-3L194.81.26l39,8.52-5.09,1.42s.33,30.52-.46,33.31,3.64,3.61,3.64,16.17c0,10.06-2.06,9.67-2.47,11.42s-1.7,14.48,0,19.57,5.32,9.67,6.76,13.78-5.88,6.64-5.19,11.46-2,7.53-2.76,9.5,9.19,4.82,11.75,6.6,5.62,7.94,3.65,9.59-60,1.38-63.54,1.65-2.32,3.94-2.68,6.65-9.39,2.56-14.91,1.57-3.76-3.75-4-6.56-6.89-.15-11.64-1.37-5.91-4.51-7.48-4.42-9.29-3.44-11.24-4.24-5,.8-7.09.16a4,4,0,0,0-4.16.67c-1.16.82-10.29,0-15.84-1s-8.87.75-12.65.54S85,125.61,82.87,123s-2.85,11.45-6.2,11.84-6.53-1.37-8.34-2.87-6.08,2.09-9.83,3,1.38,5.77.41,8.21-4.16,3.29-6.95,3.65-11,.82-12.19-2,1-15.15.91-15.94S38,127.19,35,127.35s-7.13-2.17-9.42-2.73-6.91,1.39-7.44-.36,1.59-10.48,1.59-10.48H.26S1.14,94.6,1.73,88.7Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandkrBorder);
export default __webpack_public_path__ + "static/media/brandkår-border.c207058583e2ea6e0870266eb5fb0471.svg";
export { ForwardRef as ReactComponent };